const envValueKey = "env_values"

export const getEmOauthApi = async function (EMSessionID:string) {
    let environment = await getEnv("REACT_APP_ENVIRONMENT");
    let oauthUri = await getEnv("REACT_APP_EM_OAUTH_API_BASE_URL");
    if ((window.location.host.includes("ariessc.com") && EMSessionID !== "") ||
        (window.location.host.includes("editorialmanager.com") && EMSessionID === ""))
    {
        oauthUri = await getEnv("REACT_APP_EM_OAUTH_ARIESSC_URL");
    }
    
    return oauthUri;
}

export const getEnv = async function (key: string) {

    let envValues = sessionStorage.getItem(envValueKey)

    if (envValues == null) {
        console.log("Getting env values")

        return await fetch("/env.json")
            .then(v => v.json())
            .then(v => {
                sessionStorage.setItem(envValueKey, JSON.stringify(v))
                let val = v[key]
                if (val === undefined) {
                    throw new Error("key [" + key + "] could not be found")
                }
                return val
            }).catch((e: any) => {
                console.error("Failed to get env values!")
                console.error(e)
                unsetOnError()
                return ""
            })
    }

    try {
        let env = JSON.parse(sessionStorage.getItem(envValueKey) || "{}")
        let val = env[key]

        if (val === undefined) {
            throw new Error("key [" + key + "] could not be found")
        }

        return val.toString();

    } catch (e: any) {
        console.error("Failed to JSON parse env values from sessionstorage")
        console.error(e)
        unsetOnError()
    }
}

function unsetOnError() {
    sessionStorage.removeItem(envValueKey)
}